import {generateInitialState} from "@/helpers/generateInitialState";
import {createSlice, isAnyOf} from "@reduxjs/toolkit";
import {subscriptionsInitialState} from "../initialStates";
import {checkSubscriptions, loadSubscriptions} from "./subscriptionsActions";

const initialState = await generateInitialState("subscriptions", subscriptionsInitialState);

const subscriptionSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    updateSubscriptionsState: (state, action) => {
      state.data = {...action.payload};
      state.isFetching = false;
      state.hasFailed = true;
      state.errorMsg = "";
    },
    setRequestType: (state, action) => {
      state.isFetching = false;
      state.hasFailed = false;
      state.errorMsg = "";
      state.requestType = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadSubscriptions.fulfilled, (state, action) => {
        state.data = {...action.payload};
        state.isFetching = false;
        state.hasFailed = true;
        state.errorMsg = "";
      })
      .addMatcher(isAnyOf(loadSubscriptions.pending, checkSubscriptions.pending), (state, action) => {
        state.isFetching = true;
        state.hasFailed = false;
        state.errorMsg = "";
      })
      .addMatcher(isAnyOf(loadSubscriptions.rejected, checkSubscriptions.rejected), (state, action) => {
        const {message = "Something went wrong"} = action.payload || {};

        state.hasFailed = true;
        state.isFetching = false;
        state.errorMsg = message;
      });
  },
  selectors: {
    subscriptionsSelector: state => state.data,
    requestTypeSelector: state => state.requestType,
    subscriptionStatusSelector: state => ({
      isFetching: state.isFetching,
      hasFailed: state.hasFailed,
      errorMsg: state.errorMsg,
    }),
  },
});

export const {setRequestType, updateSubscriptionsState} = subscriptionSlice.actions;
export const {subscriptionsSelector, requestTypeSelector, subscriptionStatusSelector} = subscriptionSlice.selectors;
export default subscriptionSlice.reducer;
